import AuthLayout from "layouts/AuthLayout";
import { useHistory, useLocation } from "react-router-dom";
import { toAuthUrl } from "utils/authModal";
import Individual from "./Individual";
import Institution from "./Institution";
import AuthHeading from "components/v2/Auth/AuthHeading";
import { FiUser } from "react-icons/fi";
import { BsBuilding } from "react-icons/bs";
import { FiCheck } from "react-icons/fi";

const accountTypes = [
	{
		id: "individual",
		label: "Individual",
		hint: "Personal reading",
		icon: FiUser,
	},
	{
		id: "institution",
		label: "Institution",
		hint: "School or organization",
		icon: BsBuilding,
	},
];

const Register = () => {
	const location = useLocation();
	const history = useHistory();
	const type = new URLSearchParams(location.search).get("authType") === "institution"
		? "institution" : "individual";

	return (
		<AuthLayout>
			<AuthHeading heading="Make yourself at home" subheading="A world of books. One account to explore it all." />

			<div
				className="auth-account-types"
				role="group"
				aria-label="Account type"
			>
				{accountTypes.map(({ id, label, hint, icon: Icon }) => {
					const selected = type === id;

					return (
						<button
							key={id}
							type="button"
							className={`auth-account-type ${selected ? "is-selected" : ""}`}
							onClick={() => history.replace(toAuthUrl(location, "register", { type: id }))}
							aria-pressed={selected}
						>
							<span
								className="auth-account-type__icon"
								aria-hidden="true"
							>
								<Icon size={16} />
							</span>
							<span className="min-w-0">
								<span className="auth-account-type__label">
									{label}
								</span>
								<span className="auth-account-type__hint">
									{hint}
								</span>
							</span>
							{selected && <FiCheck className="auth-account-type__check" aria-hidden="true" />}
						</button>
					);
				})}
			</div>

			{type === "institution" ? <Institution /> : <Individual />}
		</AuthLayout>
	);
};

export default Register;
